import React from "react";
import { motion } from "framer-motion";

const AboutUsBody4 = () => {
  return (
    <motion.section
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1 }}
      className="bg-gradient-to-r from-[#191c20] to-[#29313F] text-white py-16 px-6 text-center rounded-xl shadow-md"
    >
      <h2 className="text-4xl font-bold mb-4 tracking-wide">Let’s Work Together</h2>
      <p className="text-xl mb-8 max-w-2xl mx-auto">
        Have a project in mind? Get in touch with our team and let us bring your ideas to life with innovative solutions.
      </p>
      <a href="/contactus">
        <button className="bg-white text-[#F97316] py-3 px-6 rounded-xl shadow-lg hover:bg-[#FFB913] transition-all duration-300">
          Contact Us
        </button>
      </a>
    </motion.section>
  );
};

export default AboutUsBody4;
